import type { FieldConfigOverride } from "../types";

export const US_KYB_OVERRIDE: FieldConfigOverride = {
	id: "US-any-kyb-v1",
	incorporationCountry: "US",
	flowType: "KYB",
	version: "1.0.0",
	priority: 20,

	fieldOverrides: {
		entityType: {
			options: [
				{ value: "C-Corp", label: { en: "C Corporation" } },
				{ value: "S-Corp", label: { en: "S Corporation" } },
				{ value: "LLC", label: { en: "Limited Liability Company (LLC)" } },
				{ value: "LLP", label: { en: "Limited Liability Partnership (LLP)" } },
				{ value: "Partnership", label: { en: "Partnership" } },
				{ value: "Nonprofit", label: { en: "Nonprofit / 501(c)(3)" } },
				{ value: "Sole Proprietorship", label: { en: "Sole Proprietorship" } },
				{ value: "Trust", label: { en: "Trust" } },
			],
		},
		registrationNumber: {
			label: { en: "State Registration Number / Articles of Incorporation" },
			helpText: {
				en: "The registration number assigned by your state's Secretary of State office.",
			},
		},
	},

	additionalFields: [
		{
			fieldId: "federalTaxId",
			step: 1,
			section: "company_basics",
			order: 65,
			label: { en: "Federal Tax ID (EIN)" },
			type: "text",
			visible: true,
			required: true,
			validationRules: [
				{ type: "required", message: "EIN is required for US entities" },
				{
					type: "regex",
					value: "^\\d{2}-\\d{7}$",
					message: "EIN must be in format XX-XXXXXXX",
				},
			],
			placeholder: { en: "12-3456789" },
			helpText: {
				en: "Your 9-digit Employer Identification Number issued by the IRS.",
			},
		},
	],

	// FinCEN beneficial ownership rule: 25%
	uboDisclosureThreshold: 25,
};
